import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import StickyHeader from 'components/StickyHeader'
import Media from 'components/common/Media'
import LogoPrint from 'components/common/LogoPrint/LogoPrint'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import Stepper from 'components/QuickAppointmentPage/Stepper'
import Checkout from 'components/AppointmentConfirmationPage/Checkout'
import ThreeStepper from 'components/QuickAppointmentPage/ThreeStepper'
import { MAIN_CONTENT, FOOTER } from 'constant'

const Appointment = ({
  placeholders: { footer = [], header = [], mainContent = []} = {},
  quickAppointmentStepper,
  threeStepperEnabled,
  hideMainContent,
  quotePageEnabled,
  componentInitialized,
  ...props
}) =>
  <Fragment>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader data-printless />
    </StickyHeaderWrapper>
    <LogoPrint />
    <Wrapper id={ MAIN_CONTENT } tabIndex="-1" hideMainContent={ !componentInitialized || hideMainContent } data-max-width data-max-width-padding>
      {
        threeStepperEnabled ?
          <ThreeStepper threeStepperEnabled={ threeStepperEnabled } cartridges={ mainContent } /> :
          quickAppointmentStepper ?
            <Stepper cartridges={ mainContent } /> :
            quotePageEnabled ?
              <Checkout cartridges={ mainContent } { ...props } /> :
              mainContent
      }
    </Wrapper>
    <div id={ FOOTER }>
      { footer }
    </div>
  </Fragment>

Appointment.propTypes = {
  componentInitialized: PropTypes.bool,
  hideMainContent: PropTypes.bool,
  placeholders: PropTypes.shape({
    footer: PropTypes.arrayOf(PropTypes.shape()),
    header: PropTypes.arrayOf(PropTypes.shape()),
    mainBrandContent: PropTypes.arrayOf(PropTypes.shape())
  }),
  quickAppointmentStepper: PropTypes.bool,
  quotePageEnabled: PropTypes.bool,
  threeStepperEnabled: PropTypes.bool
}

export default Appointment

const Wrapper = styled.main`
  ${Media.tablet`
    padding: 0 20px;
  `}
  ${props => props.hideMainContent && css`
    display: none;
  `}
`
